/* @flow */
import React, { Component } from 'react';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import { graphql, createFragmentContainer } from 'react-relay';
// import Moment from 'moment';

import type { JobSessions_job } from './__generated__/JobSessions_job.graphql';
import { Grid } from '../../../components';

type Props = {
  job: JobSessions_job,
};

class JobSessions extends Component<Props> {
  renderRow = ({
    id,
    timeSlot: { startDate, duration: { totalMinutes } },
    rating,
    status,
  }) => (
    <TableRow key={id}>
      <TableRowColumn>
        {startDate}
        {/* {startDate && <Moment fromNow date={startDate} format="D MMM YYYY" />} */}
      </TableRowColumn>
      <TableRowColumn>{totalMinutes}</TableRowColumn>
      <TableRowColumn>
        {rating && (
          <div>
            {rating.studentRating} / 5 <br />
            {rating.studentComment}
          </div>
        )}
      </TableRowColumn>
      <TableRowColumn>
        {rating && (
          <div>
            {rating.tutorRating} / 5 <br />
            {rating.tutorComment}
          </div>
        )}
      </TableRowColumn>
      <TableRowColumn>{status}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { job } = this.props;

    const headers = [
      'Start Date',
      'Total Minutes',
      'Student Rating',
      'Tutor Rating',
      'Status',
    ];

    return (
      <div>
        <Grid
          headers={headers}
          renderRow={this.renderRow}
          rows={job.sessions}
        />
      </div>
    );
  }
}

export default createFragmentContainer(JobSessions, {
  job: graphql`
    fragment JobSessions_job on Job {
      sessions {
        id
        status
        timeSlot {
          duration {
            totalMinutes
          }
          startDate
        }
        rating {
          studentRating
          studentComment
          tutorRating
          tutorComment
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/job/components/JobSessions.js